import axios from 'axios';

export const SESSION_EXPIRED_KEY = 'session-expired';

// Un 401 en cualquier petición significa que la sesión venció o el token no es válido: se borra
// la sesión y se vuelve al login. En el login un 401 es "contraseña incorrecta" y lo maneja la pantalla.
// Los demás errores (403, 500...) los maneja cada pantalla sin sacar al usuario.
export const registerSessionInterceptor = () => {
    axios.interceptors.response.use(
        (response) => response,
        (error) => {
            const isLoginRequest = (error.config?.url || '').includes('/auth/login');
            if (error.response?.status === 401 && !isLoginRequest) {
                localStorage.clear();
                try {
                    sessionStorage.setItem(SESSION_EXPIRED_KEY, '1');
                } catch (e) {
                    // Sin sessionStorage solo se pierde el aviso en el login
                }
                // Recarga completa para que el contexto del usuario quede vacío
                if (window.location.pathname !== '/') {
                    window.location.replace('/');
                }
            }
            return Promise.reject(error);
        }
    );
};
